import {
  inboundShipmentIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";
import { InboundShipmentStatus } from "./get-shipments";

export const bulkUpdateShipments = {
  name: "bulkUpdateShipments" as const,
  input: z.object({
    inboundShipmentIds: z.array(inboundShipmentIdFormat.schema),
    status: z
      .enum([
        InboundShipmentStatus.PENDING,
        InboundShipmentStatus.IN_TRANSIT,
        InboundShipmentStatus.PARTIALLY_RECEIVED,
        InboundShipmentStatus.RECEIVED,
      ])
      .optional(),
    destinationId: locationIdFormat.schema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
